import ImageIcon from '@material-ui/icons/Image';
import { QuotedMessage } from '@src/types';
import { useIntl } from 'react-intl';

type ChatMessageImageQuotedProps = {
  title: React.ReactNode;
  message: QuotedMessage;
};

const ChatMessageImageQuoted: React.FC<ChatMessageImageQuotedProps> = ({
  title,
  message,
}) => {
  const intl = useIntl();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        {title}
        <div className="ChatMessageContentQuoted">
          <ImageIcon style={{ marginRight: 3 }} />
          {!message?.text?.length ? (
            intl.formatMessage({ id: 'AgentChatTimeline.image.text' })
          ) : (
            <p>{message.text}</p>
          )}
        </div>
      </div>
      {/* eslint-disable-next-line jsx-a11y/alt-text*/}
      <img
        src={message.mediaUrl}
        style={{ marginLeft: 10, minWidth: 80, objectFit: 'cover', height: 60 }}
      />
    </div>
  );
};

export default ChatMessageImageQuoted;
